<section *ngIf="hodnotenie" class="p-3">

  <lib-dialog-header
    [titulok]="getTitulok()"
    [predmetNazov]="hodnotenie.predmetNazov"
    [predmetSkratka]="hodnotenie.predmetSkratkaFull"
    [uzsiLavyOkraj]="true">
  </lib-dialog-header>

  <mat-dialog-content class="mat-typography p-0">

    <div *ngFor="let h of hodnotenie.hodnotenia">
      <div class="text-center">
        <div>{{h.terminKod}} - {{h.terminPopis}}</div>
        <div><strong>{{h.hodnotenieKod}} - {{h.hodnoteniePopis}}</strong></div>
        <div>{{h.udelil}}</div>
        <div>{{h.udelilDatum | date}}</div>
      </div>
      <br/>
      <div>
        <div *ngIf="h.uznane">
          <mat-checkbox checked="checked" disabled="true">
            <span i18n>Uznané</span>
          </mat-checkbox>
        </div>
        <div *ngIf="h.dovezene">
          <mat-checkbox checked="checked" disabled="true">
            <span i18n>Dovezené</span>
          </mat-checkbox>
        </div>
        <div *ngIf="h.mozeSaPrihlasit">
          <mat-checkbox checked="checked" disabled="true">
            <span i18n>Môže sa prihlásiť</span>
          </mat-checkbox>
        </div>
      </div>
      <hr/>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button mat-dialog-close cdkFocusInitial><span i18n>Close</span></button>
  </mat-dialog-actions>

</section>

<section *ngIf="hodnotenieSS" class="p-3">

  <lib-dialog-header
    [titulok]="getTitulok()"
    [predmetNazov]="hodnotenieSS.predmetNazov"
    [predmetSkratka]="hodnotenieSS.predmetSkratkaFull"
    [uzsiLavyOkraj]="true">
  </lib-dialog-header>

  <mat-dialog-content class="mat-typography">

    <div *ngFor="let h of hodnotenieSS.hodnotenia">
      <div class="text-center">
        <div><i>{{h.terminKod}} - {{h.terminPopis}}</i></div>
        <div><b>{{h.kod}} - {{h.popis}}</b></div>
        <div>{{h.datum | date}}</div>
      </div>
      <div *ngIf="h.tema" class="mt-3">
        <div class="gray" i18n>Záverečná práca</div>
        {{h.tema}}
      </div>
      <div *ngIf="h.otazky && h.otazky.length > 0" class="mt-3">
        <div class="gray" i18n>Otázky</div>
        <ol>
          <li *ngFor="let o of h.otazky">{{o.text}}</li>
        </ol>
      </div>
      <div *ngIf="h.vyjadrenie" class="mt-3">
        <div class="gray" i18n>Vyjadrenie komisie</div>
        {{h.vyjadrenie}}
      </div>
      <hr/>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button mat-dialog-close cdkFocusInitial><span i18n>Close</span></button>
  </mat-dialog-actions>

</section>
